module.exports = __webpack_public_path__ + "img/7-1.aada8d92.jpg";